import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import styled from 'styled-components'
import withTable from 'hocs/bases/withTable'
import IconButton from 'material-ui/IconButton'
import Cancel from 'material-ui/svg-icons/navigation/cancel'
import Pagination from 'components/Navigator/Pagination'
import Wrapper from 'components/wrappers/Wrapper'
import Dropdown from 'components/materialUI/Dropdown'
import FormInput from 'components/forms/bases/FormInput'
import Overlay from 'components/modals/Overlay'
import CustomTable from './CustomTable'

const AwesomeTable = compose(
  withTable(),
)(
  styled(
    ({
      loading,
      className,
      children,
      // withTable
      pageCount,
      filteredData,
      setCurrentPage,
      itemsPerPage,
      amountOptions,
      onAmountOptionChange,
      // parent props
      config,
      // keyword
      keyword,
      onKeywordChange,
      clearKeyword,
      // sort
      sortKey,
      sortType,
      onSortByKey,
    }) => {
      return (
        <div className={className}>
          <Overlay.Loading visible={loading} />
          <Wrapper ml={2} mb={1} className={'top-actions'}>
            <FormInput
              placeholder={'Type something to search...'}
              value={keyword}
              onChange={onKeywordChange}
              style={{
                width: 256,
              }}
            />
            {keyword && (
              <IconButton onClick={clearKeyword}>
                <Cancel color={'#a5a5a5'} />
              </IconButton>
            )}
          </Wrapper>
          <CustomTable
            data={filteredData}
            config={config}
            sortKey={sortKey}
            sortType={sortType}
            onSortByKey={onSortByKey}
          />
          <Wrapper my={2} textAlign={'center'}>
            {children}
          </Wrapper>
          <Wrapper className={'bottom-actions'}>
            <Pagination
              pageCount={pageCount}
              onPageChange={setCurrentPage}
            />
            <Dropdown
              value={itemsPerPage}
              options={amountOptions}
              onChange={onAmountOptionChange}
            />
          </Wrapper>
        </div>
      )
    },
  )`
    background-color: #ffffff;
    position: relative;
    
    .custom-table {
      ${({ itemsPerPage }) => ({
    // + 1 for Header
    minHeight: `${50 * (itemsPerPage + 1)}px`,
  })}
    }
    
    .top-actions {
      display: flex;
    }
    
    .bottom-actions {
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 0 -1px 15px 0 rgba(0, 0, 0, 0.05);
      
      .paginate-container {
        margin-right: 2rem;
      }
    }
  `,
)

AwesomeTable.propTypes = {
  config: PropTypes.array.isRequired,
  loading: PropTypes.bool,
}
AwesomeTable.defaultProps = {
  loading: false,
}

export default AwesomeTable



// WEBPACK FOOTER //
// ./src/components/Table/AwesomeTable.js